import React from 'react';
import { IconSvgProps } from '@models/common';

const Eye: React.FC<IconSvgProps> = (props) => {
  const { size = 14, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.69729 7.68385C1.49804 7.25037 1.49804 6.75028 1.69729 6.3168C2.6196 4.31024 4.64726 2.91699 7.00033 2.91699C9.3534 2.91699 11.3811 4.31024 12.3034 6.3168C12.5026 6.75028 12.5026 7.25037 12.3034 7.68385C11.3811 9.69041 9.3534 11.0837 7.00033 11.0837C4.64726 11.0837 2.6196 9.69041 1.69729 7.68385Z'
        stroke='currentColor'
      />
      <path
        d='M8.75033 7.00033C8.75033 7.96682 7.96683 8.75033 7.00033 8.75033C6.03383 8.75033 5.25033 7.96682 5.25033 7.00033C5.25033 6.03383 6.03383 5.25033 7.00033 5.25033C7.96683 5.25033 8.75033 6.03383 8.75033 7.00033Z'
        stroke='currentColor'
      />
    </svg>
  );
};

export default Eye;
